import api from '../utils/api'

// 商店相關API
export const getStoreInfo = () => {
  return api({
    url: '/api/store',
    method: 'get'
  })
}

export const updateStoreInfo = (data) => {
  return api.put('/api/store/info', data)
}

// 商品相關API
export const getProducts = (params) => {
  return api({
    url: '/api/store/products',
    method: 'get',
    params
  })
}

export const getProduct = (id) => {
  return api({
    url: `/api/store/products/${id}`,
    method: 'get'
  })
}

export const createProduct = (data) => {
  return api({
    url: '/api/store/products',
    method: 'post',
    data
  })
}

export const updateProduct = (id, data) => {
  return api({
    url: `/api/store/products/${id}`,
    method: 'put',
    data
  })
}

export const updateProductStatus = (id, status) => {
  return api({
    url: `/api/store/products/${id}/status`,
    method: 'patch',
    data: { status }
  })
}

// 分類相關API
export const getCategories = () => {
  return api({
    url: '/api/store/categories',
    method: 'get'
  })
}

export const createCategory = (data) => {
  return api({
    url: '/api/store/categories',
    method: 'post',
    data
  })
}

export const updateCategory = (categoryId, data) => {
  return api({
    url: `/api/store/categories/${categoryId}`,
    method: 'put',
    data
  })
}

export const deleteCategory = (categoryId) => {
  return api({
    url: `/api/store/categories/${categoryId}`,
    method: 'delete'
  })
}

export const getStoreStats = () => {
  return api({
    url: '/api/store/stats',
    method: 'GET'
  })
}

// 产品排序相关API（舊版 business_B 路徑，依專案保留）
export const reorderProducts = (businessId, productOrders) => {
  return api({
    url: `/api/business_B/${businessId}/products/reorder`,
    method: 'put',
    data: { productOrders }
  })
}

// 商店商品排序（store 路徑，req.businessId 自動帶入）
export const reorderStoreProducts = (productIds) => {
  return api({
    url: '/api/store/products/reorder',
    method: 'put',
    data: { productIds }
  })
}
